import { globals } from '../../globals'
// ------------------------------------
// Constants
// ------------------------------------
export const START_DATA_FETCH = 'START_DATA_FETCH'
export const DATA_FETCHED = 'DATA_FETCHED'
export const FETCH_FAILED = 'FETCH_FAILED'
export const SAVE_GROUP_NOTES_OPTIONS = 'SAVE_GROUP_NOTES_OPTIONS'
export const RETURN_DEFAULT_REPORT = 'RETURN_DEFAULT_REPORT'
export const OPEN_SAVED_REPORT = 'OPEN_SAVED_REPORT'
// ------------------------------------
// Actions
// ------------------------------------
export const getFormData = (location) => {
  return (dispatch) => {
    dispatch({ type: START_DATA_FETCH })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      headers,
      credentials: 'include',
    }
    fetch(`${globals.apiUrl}/api/trackform?SearchType=${location.page}&ReportId=0`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        dispatch({ type: FETCH_FAILED, payload: { errorCode: response.status } })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: DATA_FETCHED,
          payload: {
            json,
          },
          location: {
            page: location.page,
            field: location.field,
          },
        })
        dispatch({
          type: SAVE_GROUP_NOTES_OPTIONS,
          payload: {
            json
          },
          location: {
            page: location.page,
          }
        })
        if (json.DefaultReport !== null) {
          dispatch({
            type: OPEN_SAVED_REPORT,
            payload: {
              json: json.DefaultReport,
            },
            page: location.page,
            id: json.DefaultReport.ReportId,
          })
        } else {
          dispatch({
            type: RETURN_DEFAULT_REPORT,
            page: location.page,
          })
        }
      }
    }).catch((err) => {
      dispatch({ type: FETCH_FAILED, payload: {} })
      console.log(err.message)
    })
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
export const getFormDataHandlers = {
  [START_DATA_FETCH] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [FETCH_FAILED] : (state, action) => {
    return {
      ...state,
      errorCode: action.payload.errorCode,
      isFetchingData: false
    }
  }
}

export const actionGroupNoteHandler = (state, action) => {
  if (!action.payload.json.FieldList) {
    return {
      ...state
    }
  }
  const { page } = action.location
  const checkboxesIds = action.payload.json.FieldList.map(item => {
    if (item.DisplayType) return `view${item.Name}`
  }).filter(item => {
    return item
  })
  return {
    ...state,
    formDataValue: {
      ...state.formDataValue,
      [page]: {
        ...state.formDataValue[page],
        groupNotesOptions: {
          ...state.formDataValue[page].groupNotesOptions,
          selected: [
            ...state.formDataValue[page].groupNotesOptions.selected,
            ...checkboxesIds
          ]
        }
      }
    },
    renderData: {
      ...state.renderData,
      [page]: {
        ...state.renderData[page]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/getFormData.js